import { render, staticRenderFns } from "./TopbarNotificationPanel.vue?vue&type=template&id=afc7c4ba&"
import script from "./TopbarNotificationPanel.vue?vue&type=script&lang=js&"
export * from "./TopbarNotificationPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports